import Page from "webPage/Page";
import Gallery from "base/Gallery";
import "particles.js";
import GlobalEvents from "base/GlobalEvents";
import VideoHelper from "video/VideoHelper";

const SLIDER_TIMEOUT = 7000;

Page.register('/about-us', () => {
    let gallery = new Gallery($(".js-slider"), {
        itemClass: "slider__slide",
        pipClass: "slider__slide-icon",
        itemsClass: 'js-items',
        animationDuration: 1000,
    });

    let timeout;
    let cancelled = false;

    gallery.on("goTo navigate", () => {
        if (timeout) clearTimeout(timeout);
        cancelled = true;

        $(".js-slider-progress").css("opacity", 0);
    }).on("transitionEnd", () => {
        if (cancelled) return;
        timeout = setTimeout(nextItem, SLIDER_TIMEOUT);

        $(".js-slider-progress").css("width", "100%");
    });

    function nextItem() {
        if (cancelled) return;
        gallery.navigate(Gallery.FORWARDS);
        let $progress = $(".js-slider-progress");
        $progress.css("opacity", 0);
        setTimeout(() => {
            $progress.hide().css({width: 0, opacity: 1});
            setTimeout(() => {
                $progress.show();
            }, 200);
        }, 500);
    }

    $(".js-slider-progress").css("width", "100%");
    timeout = setTimeout(nextItem, SLIDER_TIMEOUT);

    window.particlesJS.load('slider-particles', '/about-slider-particles.json');

    $("body").on("click", ".js-watch-video", function () {
        let $modal = $(".js-video-modal");
        let $modalContent = $modal.find(".js-modal-content");

        let $video = eotwJSXFactory('div');

        let $wrap = eotwJSXFactory('div', {class: "video__wrapper video__wrapper--loading video__wrapper--about-pcc"}, [$video]);
        $modalContent.html($wrap);

        let player = VideoHelper.process($(this).attr("data-provider"), $(this).attr("data-video-id"), $video, {autoplay: true});

        player.on("loaded", () => {
            $wrap.addClass("video__wrapper--playing");
        });
        let fn = () => {
            GlobalEvents.off('website.modal.close', fn);
            player.destroy();
        };
        GlobalEvents.on('website.modal.close', fn);

        $("body").addClass("modal-active");
        $modal.addClass("modal--active");

        return false;
    })
});
